import React from 'react';
import { compose } from 'ramda';
import { withProps, branch, renderNothing } from 'recompose';
import { withTranslations } from 'js/components/hocs/withTranslations';
import { Button } from 'js/components/common/Button';
import { Icon } from 'js/components/common/Icon';
import { isJoinButtonAvailable } from '../../helpers';
import useJoinLeaveButtonProps from './../useJoinLeaveButtonProps';
import { registrationStatuses } from '../../constants';
import style from './index.scss';

export const JoinButton = ({
   t,
   buttonView,
   disabled,
   onClick,
   title,
   joined,
   className = '',
   variant = 'rounded',
   color = 'success',
   size = 'large'
}) => (
    <div className={style.container}>
       <Button
           view={buttonView}
           variant={variant}
           color={color}
           size={size}
           disabled={disabled}
           onClick={onClick}
           className={`${style.join} ${className}`}
       >
              {joined && <Icon type="joined"/>}
              {t(title)}
       </Button>
    </div>
);

export default compose(
    branch(
        ({ joined, registrationStatus }) => !isJoinButtonAvailable({ joined, registrationStatus }),
        renderNothing
    ),
    withTranslations,
    withProps(({ joined, registrationStatus, leaderboardId, participantsCount, maxParticipantsCount }) => {
        const isMaxParticipantsReached = maxParticipantsCount
                && participantsCount
                && participantsCount === maxParticipantsCount;
        const isReadOnly = joined || isMaxParticipantsReached;
        const type = joined
                ? 'joined'
                : isMaxParticipantsReached
                    ? 'soldOut'
                    : 'joinRace';

        const { disabled, onClick } = useJoinLeaveButtonProps('join')({ leaderboardId });

        const props = {
            title: `playtech.mobile.system.leaderboard.button.${type}`,
            buttonView: isReadOnly ? 'readonly' : 'primary'
        };

        return isReadOnly
            ? props
            : {
                ...props,
                disabled: registrationStatus === registrationStatuses.NOT_STARTED || disabled,
                onClick
            };
    })
)(JoinButton);
